// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Fleet Performance Icon.
 * @param {IconProps} props - The IconProps for the FleetPerformanceIcon component.
 * @returns {ReactElement} The FleetPerformanceIcon component.
 */
export const FleetPerformanceIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon width='35' height='33' viewBox='0 0 35 33' color={color} fill='transparent' {...rest} id='fleet-performance'>
      <path
        d='M17.0752 1.07495V8.00294'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.0752 20.9891V13.5413L3.81459 19.3396C3.81459 19.3396 3.11452 26.6075 7.32504 29.4666'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.0752 13.5413L30.3358 19.3396C30.3358 19.3396 30.8735 24.858 28.2153 28.167'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.8761 14.431V17.651'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.26428 17.8201V9.14261C7.26428 7.51308 8.60354 6.18347 10.2675 6.18347H21.4786'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.0752 27.8971C2.59707 30.9871 6.4322 32.1171 9.9528 29.9671C10.8355 29.4271 11.7486 28.1771 13.5952 28.2171C15.3301 28.2571 15.6548 29.2871 17.2071 30.0471C18.8406 30.8471 20.8393 30.8771 22.4931 30.1271C23.3554 29.7271 24.1265 29.1371 24.9889 28.7371C27.7486 27.4471 31.4011 28.4671 33.065 30.9971'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M23.2438 3.45422H33.0751'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M30.6605 5.83422L33.0752 3.45422'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M30.6605 1.07495L33.0752 3.45495'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M33.0751 8.96265H23.2438'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.6585 6.58337L23.2438 8.96338'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.6585 11.3527L23.2438 8.97266'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Icon>
  );
};
